import React from "react";
import { FaGift } from "react-icons/fa";
import { elakayAutoText } from "../../pageInside/dataElakay";

// Redesign ticket §17: never show contradictory pricing. While a free trial is active, the
// headline is the CURRENT offer ("FREE for N months"); the real priceMonth/priceYear already in
// plans.js becomes a clearly-labeled, muted "regular price after the free period" line -- no
// number is invented, and `plan.prixAvailable` (whether real charging is live) is untouched.
const RolePricing = ({ plan, showTrial, tr }) => {
  if (showTrial) {
    return (
      <div className="userstep-plan-price userstep-plan-price--trial">
        <div className="userstep-plan-price-headline">
          <FaGift className="userstep-plan-price-headline-icon" aria-hidden="true" />
          <span>
            {elakayAutoText("h_userstep_price_free_headline", "FREE for {value0} months", {
              value0: plan.freeTrialMonths,
            })}
          </span>
        </div>
        <div className="userstep-plan-price-sub">
          {tr("title", "startFreeUpgradeAnytime", "Start free, upgrade anytime")}
        </div>
        <div className="userstep-plan-price-regular">
          {elakayAutoText(
            "h_userstep_price_regular_after_trial",
            "Regular price after the free period: {value0}/mo or {value1}/yr",
            { value0: `$${plan.priceMonth}`, value1: `$${plan.priceYear}` }
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="userstep-plan-price">
      <div className="userstep-plan-price-main">
        <span className="userstep-plan-price-currency">$</span>
        <span className="userstep-plan-price-amount">{plan.prixAvailable ? plan.priceMonth : 0}</span>
        <span className="userstep-plan-price-period">/ {tr("label", "month", "month")}</span>
      </div>
      <div className="userstep-plan-price-year">
        <span>{tr("label", "or", "or")}</span>
        <strong>${plan.prixAvailable ? plan.priceYear : 0}</strong>
        <span>/ {tr("label", "years", "year")}</span>
      </div>
    </div>
  );
};

export default RolePricing;
